/**
 * Token scope for surfaces rendered through the #943 elevated portal.
 *
 * The theme tokens (--hfse-card-bg, --hfse-foreground, …) are emitted onto
 * `.hfse-explorer-container` and `.hr-dialog-content`. A portal target is a
 * DETACHED shadow host at document.body, so it inherits neither — and the pro
 * Where listbox's portal wrapper carried only `.hfse`, which no token rule
 * matches. Every `var(--hfse-*, <light literal>)` inside it therefore resolved
 * to its LIGHT fallback, which is invisible in light mode and paints a white
 * popover over a dark widget in dark mode.
 *
 * Adding a third, LAYOUT-FREE scope class (rather than reusing
 * `.hfse-explorer-container`, which carries real layout rules) fixes the
 * portal without changing any box. `mirrorHostTheme` already copies
 * `data-hr-theme` onto the portal host, so the dark arm matches once the class
 * is present. Pinned by explorer-elevated-token-scope.test.tsx.
 *
 * Own module (#1259): useExplorerCss (theme tokens) and searchbarCss
 * (--hfse-sbp-* tokens) both emit onto the scope, and searchbarCss is
 * imported BY useExplorerCss — the constant lives below both so neither has
 * to import the other. useExplorerCss re-exports it for the existing sites.
 */
export const ELEVATED_TOKEN_SCOPE = 'hfse-elevated-scope'
